var cov_2b14ihjwul = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/accumulateChartSyncfusion.js',
      hash = '5dff1b49807ae05e56a55fcfed5ae8283d351ab6',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/accumulateChartSyncfusion.js',
    statementMap: {
      '0': {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 151,
          column: 3
        }
      },
      '1': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 150,
          column: 4
        }
      },
      '2': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 35,
          column: 7
        }
      },
      '3': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 25
        }
      },
      '4': {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 95,
          column: 7
        }
      },
      '5': {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      '6': {
        start: {
          line: 49,
          column: 10
        },
        end: {
          line: 49,
          column: 32
        }
      },
      '7': {
        start: {
          line: 50,
          column: 10
        },
        end: {
          line: 50,
          column: 29
        }
      },
      '8': {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 56,
          column: 9
        }
      },
      '9': {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 55,
          column: 17
        }
      },
      '10': {
        start: {
          line: 60,
          column: 25
        },
        end: {
          line: 71,
          column: 9
        }
      },
      '11': {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 88,
          column: 9
        }
      },
      '12': {
        start: {
          line: 76,
          column: 10
        },
        end: {
          line: 87,
          column: 11
        }
      },
      '13': {
        start: {
          line: 77,
          column: 24
        },
        end: {
          line: 77,
          column: 25
        }
      },
      '14': {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 82,
          column: 13
        }
      },
      '15': {
        start: {
          line: 80,
          column: 14
        },
        end: {
          line: 80,
          column: 51
        }
      },
      '16': {
        start: {
          line: 81,
          column: 14
        },
        end: {
          line: 81,
          column: 22
        }
      },
      '17': {
        start: {
          line: 84,
          column: 12
        },
        end: {
          line: 86,
          column: 13
        }
      },
      '18': {
        start: {
          line: 85,
          column: 14
        },
        end: {
          line: 85,
          column: 57
        }
      },
      '19': {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 91,
          column: 68
        }
      },
      '20': {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 94,
          column: 41
        }
      },
      '21': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 101,
          column: 9
        }
      },
      '22': {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 28
        }
      },
      '23': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 100,
          column: 17
        }
      },
      '24': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 15
        }
      },
      '25': {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 133,
          column: 9
        }
      },
      '26': {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 108,
          column: 28
        }
      },
      '27': {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 113,
          column: 9
        }
      },
      '28': {
        start: {
          line: 112,
          column: 10
        },
        end: {
          line: 112,
          column: 17
        }
      },
      '29': {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 116,
          column: 9
        }
      },
      '30': {
        start: {
          line: 115,
          column: 10
        },
        end: {
          line: 115,
          column: 17
        }
      },
      '31': {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 70
        }
      },
      '32': {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 132,
          column: 17
        }
      },
      '33': {
        start: {
          line: 124,
          column: 10
        },
        end: {
          line: 124,
          column: 92
        }
      },
      '34': {
        start: {
          line: 127,
          column: 10
        },
        end: {
          line: 131,
          column: 19
        }
      },
      '35': {
        start: {
          line: 128,
          column: 12
        },
        end: {
          line: 128,
          column: 57
        }
      },
      '36': {
        start: {
          line: 129,
          column: 12
        },
        end: {
          line: 129,
          column: 29
        }
      },
      '37': {
        start: {
          line: 130,
          column: 12
        },
        end: {
          line: 130,
          column: 44
        }
      },
      '38': {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 142,
          column: 7
        }
      },
      '39': {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 141,
          column: 11
        }
      },
      '40': {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 138,
          column: 33
        }
      },
      '41': {
        start: {
          line: 140,
          column: 10
        },
        end: {
          line: 140,
          column: 67
        }
      },
      '42': {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 148,
          column: 9
        }
      },
      '43': {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      '44': {
        start: {
          line: 146,
          column: 10
        },
        end: {
          line: 146,
          column: 32
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 22,
            column: 61
          },
          end: {
            line: 22,
            column: 62
          }
        },
        loc: {
          start: {
            line: 22,
            column: 73
          },
          end: {
            line: 151,
            column: 1
          }
        },
        line: 22
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 46,
            column: 21
          },
          end: {
            line: 46,
            column: 22
          }
        },
        loc: {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 95,
            column: 7
          }
        },
        line: 46
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 97,
            column: 19
          },
          end: {
            line: 97,
            column: 20
          }
        },
        loc: {
          start: {
            line: 97,
            column: 28
          },
          end: {
            line: 99,
            column: 7
          }
        },
        line: 97
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 99,
            column: 9
          },
          end: {
            line: 99,
            column: 10
          }
        },
        loc: {
          start: {
            line: 99,
            column: 21
          },
          end: {
            line: 101,
            column: 7
          }
        },
        line: 99
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 107,
            column: 19
          },
          end: {
            line: 107,
            column: 20
          }
        },
        loc: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 109,
            column: 7
          }
        },
        line: 107
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 109,
            column: 9
          },
          end: {
            line: 109,
            column: 10
          }
        },
        loc: {
          start: {
            line: 109,
            column: 21
          },
          end: {
            line: 133,
            column: 7
          }
        },
        line: 109
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 18
          }
        },
        loc: {
          start: {
            line: 122,
            column: 23
          },
          end: {
            line: 132,
            column: 9
          }
        },
        line: 122
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 127,
            column: 19
          },
          end: {
            line: 127,
            column: 20
          }
        },
        loc: {
          start: {
            line: 127,
            column: 25
          },
          end: {
            line: 131,
            column: 11
          }
        },
        line: 127
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 137,
            column: 36
          },
          end: {
            line: 137,
            column: 37
          }
        },
        loc: {
          start: {
            line: 137,
            column: 45
          },
          end: {
            line: 141,
            column: 9
          }
        },
        line: 137
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 144,
            column: 28
          },
          end: {
            line: 144,
            column: 29
          }
        },
        loc: {
          start: {
            line: 144,
            column: 34
          },
          end: {
            line: 148,
            column: 7
          }
        },
        line: 144
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }],
        line: 33
      },
      '1': {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 48
      },
      '2': {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 56,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 56,
            column: 9
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 56,
            column: 9
          }
        }],
        line: 54
      },
      '3': {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }],
        line: 75
      },
      '4': {
        loc: {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        }, {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        }],
        line: 84
      },
      '5': {
        loc: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 113,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 113,
            column: 9
          }
        }, {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 113,
            column: 9
          }
        }],
        line: 111
      },
      '6': {
        loc: {
          start: {
            line: 111,
            column: 14
          },
          end: {
            line: 111,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 111,
            column: 14
          },
          end: {
            line: 111,
            column: 27
          }
        }, {
          start: {
            line: 111,
            column: 31
          },
          end: {
            line: 111,
            column: 44
          }
        }],
        line: 111
      },
      '7': {
        loc: {
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        }, {
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        }],
        line: 114
      },
      '8': {
        loc: {
          start: {
            line: 119,
            column: 28
          },
          end: {
            line: 119,
            column: 69
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 119,
            column: 28
          },
          end: {
            line: 119,
            column: 46
          }
        }, {
          start: {
            line: 119,
            column: 50
          },
          end: {
            line: 119,
            column: 69
          }
        }],
        line: 119
      },
      '9': {
        loc: {
          start: {
            line: 124,
            column: 29
          },
          end: {
            line: 124,
            column: 58
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 124,
            column: 45
          },
          end: {
            line: 124,
            column: 50
          }
        }, {
          start: {
            line: 124,
            column: 53
          },
          end: {
            line: 124,
            column: 58
          }
        }],
        line: 124
      },
      '10': {
        loc: {
          start: {
            line: 124,
            column: 60
          },
          end: {
            line: 124,
            column: 90
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 124,
            column: 60
          },
          end: {
            line: 124,
            column: 79
          }
        }, {
          start: {
            line: 124,
            column: 83
          },
          end: {
            line: 124,
            column: 90
          }
        }],
        line: 124
      },
      '11': {
        loc: {
          start: {
            line: 128,
            column: 32
          },
          end: {
            line: 128,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 128,
            column: 32
          },
          end: {
            line: 128,
            column: 50
          }
        }, {
          start: {
            line: 128,
            column: 54
          },
          end: {
            line: 128,
            column: 56
          }
        }],
        line: 128
      },
      '12': {
        loc: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }, {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }],
        line: 136
      },
      '13': {
        loc: {
          start: {
            line: 140,
            column: 36
          },
          end: {
            line: 140,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 140,
            column: 36
          },
          end: {
            line: 140,
            column: 54
          }
        }, {
          start: {
            line: 140,
            column: 58
          },
          end: {
            line: 140,
            column: 65
          }
        }],
        line: 140
      },
      '14': {
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }, {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }],
        line: 145
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2b14ihjwul.s[0]++;

angular.module('app').directive('accumulateChartSyncfusion', function ($timeout) {
  cov_2b14ihjwul.f[0]++;
  cov_2b14ihjwul.s[1]++;

  return {
    restrict: 'A',
    scope: {
      params: '=',
      export: '=?',
      exportWithRightClick: '=?' },
    template: '<div></div>',
    link: function link(scope, element, attrs) {
      cov_2b14ihjwul.s[2]++;

      if (!scope.export) {
        cov_2b14ihjwul.b[0][0]++;
        cov_2b14ihjwul.s[3]++;

        scope.export = 0;
      } else {
        cov_2b14ihjwul.b[0][1]++;
      }

      cov_2b14ihjwul.s[4]++;

      var render = function render() {
        cov_2b14ihjwul.f[1]++;
        cov_2b14ihjwul.s[5]++;

        if (scope.chart) {
          cov_2b14ihjwul.b[1][0]++;
          cov_2b14ihjwul.s[6]++;

          scope.chart.destroy();
          cov_2b14ihjwul.s[7]++;
          scope.chart = null;
        } else {
          cov_2b14ihjwul.b[1][1]++;
        }

        cov_2b14ihjwul.s[8]++;

        if (!scope.params) {
          cov_2b14ihjwul.b[2][0]++;
          cov_2b14ihjwul.s[9]++;

          return;
        } else {
          cov_2b14ihjwul.b[2][1]++;
        }

        var palettes = (cov_2b14ihjwul.s[10]++, ['#BAF171', '#C4EAF6', '#E9B1FF', '#F49C94', '#FCF086', '#58D740', '#7DDAF8', '#CA6FEE', '#FE855F', '#F9E850', '#1EB799', '#29DAE9', '#B145F4', '#CD5145', '#EDDA2F', '#2EAB77', '#20C9B3', '#6F43EA', '#EB5757', '#EDC32F', '#66AF45', '#33ACED', '#562EBB', '#DA4A2B', '#D39F17', '#78A73D', '#208AC9', '#792AF9', '#F35634', '#B8953B', '#A5B212', '#3160BC', '#651E91', '#AE534B', '#F38434', '#12A5B2', '#5C83E7', '#911E71', '#7E3737', '#D36617', '#2F7980', '#035C88', '#401C5B', '#5E4138', '#B66225', '#0E3E53', '#093B69', '#240E35', '#3E2B11', '#B24712']);

        cov_2b14ihjwul.s[11]++;

        if (scope.params.series) {
          cov_2b14ihjwul.b[3][0]++;
          cov_2b14ihjwul.s[12]++;

          for (var _iterator = scope.params.series, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var series = _ref;

            var index = (cov_2b14ihjwul.s[13]++, 0);
            cov_2b14ihjwul.s[14]++;
            for (var _iterator2 = series.dataSource, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
              var _ref2;

              if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
              } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
              }

              var item = _ref2;
              cov_2b14ihjwul.s[15]++;

              item.deltaAppColor = palettes[index];
              cov_2b14ihjwul.s[16]++;
              index++;
            }
            cov_2b14ihjwul.s[17]++;

            if (!series.pointColorMapping) {
              cov_2b14ihjwul.b[4][0]++;
              cov_2b14ihjwul.s[18]++;

              series.pointColorMapping = 'deltaAppColor';
            } else {
              cov_2b14ihjwul.b[4][1]++;
            }
          }
        } else {
          cov_2b14ihjwul.b[3][1]++;
        }

        cov_2b14ihjwul.s[19]++;

        scope.chart = new ej.charts.AccumulationChart(scope.params);

        cov_2b14ihjwul.s[20]++;

        scope.chart.appendTo(element[0]);
      };
      cov_2b14ihjwul.s[21]++;

      scope.$watch(function (scope) {
        cov_2b14ihjwul.f[2]++;
        cov_2b14ihjwul.s[22]++;

        return scope.params;
      }, function (newValue) {
        cov_2b14ihjwul.f[3]++;
        cov_2b14ihjwul.s[23]++;

        render();
      });

      cov_2b14ihjwul.s[24]++;

      render();

      cov_2b14ihjwul.s[25]++;

      scope.$watch(function (scope) {
        cov_2b14ihjwul.f[4]++;
        cov_2b14ihjwul.s[26]++;

        return scope.export;
      }, function (newValue) {
        cov_2b14ihjwul.f[5]++;
        cov_2b14ihjwul.s[27]++;

        if (!((cov_2b14ihjwul.b[6][0]++, newValue == 1) || (cov_2b14ihjwul.b[6][1]++, newValue == 2))) {
          cov_2b14ihjwul.b[5][0]++;
          cov_2b14ihjwul.s[28]++;

          return;
        } else {
          cov_2b14ihjwul.b[5][1]++;
        }
        cov_2b14ihjwul.s[29]++;
        if (!scope.params) {
          cov_2b14ihjwul.b[7][0]++;
          cov_2b14ihjwul.s[30]++;

          return;
        } else {
          cov_2b14ihjwul.b[7][1]++;
        }

        cov_2b14ihjwul.s[31]++;

        scope.chart.title = (cov_2b14ihjwul.b[8][0]++, scope.params.title) || (cov_2b14ihjwul.b[8][1]++, scope.params.title_);

        cov_2b14ihjwul.s[32]++;

        $timeout(function () {
          cov_2b14ihjwul.f[6]++;
          cov_2b14ihjwul.s[33]++;

          scope.chart.export(newValue == 1 ? (cov_2b14ihjwul.b[9][0]++, 'PNG') : (cov_2b14ihjwul.b[9][1]++, 'PDF'), (cov_2b14ihjwul.b[10][0]++, scope.params.title_) || (cov_2b14ihjwul.b[10][1]++, 'chart'));

          cov_2b14ihjwul.s[34]++;

          $timeout(function () {
            cov_2b14ihjwul.f[7]++;
            cov_2b14ihjwul.s[35]++;

            scope.chart.title = (cov_2b14ihjwul.b[11][0]++, scope.params.title) || (cov_2b14ihjwul.b[11][1]++, '');
            cov_2b14ihjwul.s[36]++;
            scope.export = 0;cov_2b14ihjwul.s[37]++;

            scope.$emit('afterChartExport');
          }, 1000);
        }, 1500);
      });

      cov_2b14ihjwul.s[38]++;

      if (scope.exportWithRightClick) {
        cov_2b14ihjwul.b[12][0]++;
        cov_2b14ihjwul.s[39]++;

        element.bind('contextmenu', function (event) {
          cov_2b14ihjwul.f[8]++;
          cov_2b14ihjwul.s[40]++;

          event.preventDefault();cov_2b14ihjwul.s[41]++;

          scope.chart.export('PNG', (cov_2b14ihjwul.b[13][0]++, scope.params.title) || (cov_2b14ihjwul.b[13][1]++, 'chart'));
        });
      } else {
        cov_2b14ihjwul.b[12][1]++;
      }

      cov_2b14ihjwul.s[42]++;
      scope.$on('$destroy', function () {
        cov_2b14ihjwul.f[9]++;
        cov_2b14ihjwul.s[43]++;

        if (scope.chart) {
          cov_2b14ihjwul.b[14][0]++;
          cov_2b14ihjwul.s[44]++;

          scope.chart.destroy();
        } else {
          cov_2b14ihjwul.b[14][1]++;
        }
      });
    }
  };
});